import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get groups
export const getGroups = createAsyncThunk("groups/getGroups", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getGroups({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all groups
export const getAllGroups = createAsyncThunk("groups/getAllGroups", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllGroups();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("groups/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("groups/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("groups/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageGroups({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create groups
export const createGroups = createAsyncThunk("groups/createGroups", async (data, { rejectWithValue }) => {
  const { name, code, accountGroup, isActive } = data;
  try {
    const body = JSON.stringify({ name, code, accountGroup, isActive });
    const { data } = await API.createGroups(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateGroups = createAsyncThunk("groups/updateGroups", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, code, accountGroup, isActive } = values;
  try {
    const body = JSON.stringify({ name, code, accountGroup, isActive });
    const { data } = await API.updateGroups(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("groups/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
